import {useEffect, useState} from 'react';

import * as api from '../../lib/api';
import {useCredentials} from '../../lib/user';
import {receivesSharedAnswers} from '../../screens/FormBuilderScreen/shared';

// The values a single-select answer can be set to: the question's own options, then, for a question that receives
// shared answers, the answers offered from its linked sources. The answer the editor opened with is always kept, since a
// shared pick is no longer offered once it is used up and would otherwise vanish from the list, or be lost once changed.
function useRadioOptions(question, values) {
  const credentials = useCredentials();
  const receives = receivesSharedAnswers(question);
  const [sharedValues, setSharedValues] = useState([]);
  const [initialValues] = useState(values);

  useEffect(() => {
    if (!receives) {
      return;
    }

    let cancelled = false;
    api.getSharedOptions(question.id, credentials)
      .then(result => {
        if (!cancelled) {
          setSharedValues((result.sharedOptions || []).map(option => option.value));
        }
      })
      // Shared options are extra choices, so failing to load them still leaves the question's own options and the
      // current answer to pick from.
      .catch(() => {});

    return () => { cancelled = true; };
  }, [receives, question.id, credentials]);

  const options = [];
  const seen = new Set();
  [...question.questionOptions.map(option => option.value), ...(receives ? sharedValues : []), ...initialValues, ...values]
    .forEach(value => {
      if (value && !seen.has(value)) {
        seen.add(value);
        options.push(value);
      }
    });

  return options;
}

export default useRadioOptions;
